<template>
  <header
    class="pos-header"
    :style="
      routeName === '/pos-login'
        ? 'margin-bottom:0px;padding-left:10px;padding-top:10px'
        : 'margin-bottom:0px'
    "
  >
    <div
      class="row"
      :style="
        routeName === '/pos-login' ? 'margin-bottom:0px' : 'margin-bottom:10px'
      "
    >
      <div class="col-lg-12 col-12 align-items-center d-flex alignment-header">
        <div class="align-items-center d-flex">
          <span class="mr-1">
            <img
              src="@/assets/img/logos/Nuvio_Black.png"
              width="60"
              v-if="routeName !== '/pos-login'"
              height="auto"
            />
            <!-- style="filter: drop-shadow(0 0 3px var(--blue));" -->
          </span>
          <div
            v-if="
              ((section && section.movieDetail) ||
                routeName === '/pos-booking' ||
                routeName.includes('/pos-seat')) &&
                accessLimitation == 'SUPER'
            "
            class="pos-tabs"
          >
            <router-link to="/pos-booking" class="active text-decoration-none"
              >POS
            </router-link>
            <router-link
              to
              class="text-decoration-none"
              @click.native.prevent="onSwitchToFnb()"
              >FNB</router-link
            >
            <router-link
              v-if="SHOW_MERCHANDISE_MODULE == 'Y'"
              to="/merchandise"
              class="text-decoration-none"
              >MERCH</router-link
            >
          </div>
        </div>
        <div
          class="align-items-center d-flex"
          v-if="routeName == '/pos-booking'"
        >
          <section
            class="pos_movie_search_n_filters__nav mx-1"
            :class="!disableClick ? 'disabled-click' : ''"
          >
            <article class="movie_view_type_selector_new">
              <!-- FILTER BY MOVIE SECTION -->
              <span
                @click="onChangeFilter($event, 'movie')"
                :class="selectedFilterName === 'movie' ? 'active' : ''"
              >
                {{ $tc("movie", 1) }}
              </span>

              <!-- FILTER BY DATE SELECTION SLIDER -->
              <span
                @click="onChangeFilter($event, 'date')"
                :class="selectedFilterName === 'date' ? 'active' : ''"
              >
                {{ $t("date") }}
              </span>

              <!-- FILTER BY SCREEN SECTION  -->
              <span
                @click="onChangeFilter($event, 'screen')"
                :class="selectedFilterName === 'screen' ? 'active' : ''"
              >
                {{ $tc("screen", 1) }}
              </span>

              <!-- FILTER BY LANGUAGE SECTION -->
              <span
                @click="onChangeFilter($event, 'language')"
                :class="selectedFilterName === 'language' ? 'active' : ''"
              >
                {{ $tc("language", 1) }}
              </span>
            </article>
          </section>
          <span
            class="d-flex ml-3"
            style="height: 40px; cursor: pointer"
            @click="onClickHandler('Filter')"
            :class="!disableClick ? 'disabled-click' : ''"
          >
            <!-- <img
              src="@/assets/img/icons/filter-icon.svg"
              style="width: 35px"
              class="filterImg"
            /> -->
            <div class="filterImg">
              <svg width="35" height="35" viewBox="0 0 35 35">
                <defs>
                  <filter id="colorize" color-interpolation-filters="sRGB">
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 0.305
                    0 0 0 0 0.4
                    0 0 0 0 0.082
                    0 0 0 1 0"
                    />
                  </filter>
                </defs>
                <image
                  style="filter: hue-rotate(45deg);"
                  xlink:href="data:image/png;base64,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"
                  x="0"
                  y="0"
                  width="35"
                  height="35"
                  filter=""
                />
              </svg>
            </div>
            <!-- {{ $tc("Filters") }} -->
          </span>
        </div>
        <!-- Sem Version -->
        <!-- style="line-height: 1; min-width: 117px;" -->

        <div
          class="search-input mx-0 d-flex"
          style="align-items: center"
          v-if="routeName !== '/pos-login'"
        >
          <!-- main for gap:10px-->
          <b-form-input
            v-if="routeName == '/pos-booking' && false"
            :class="!disableClick ? 'disabled-click' : ''"
            v-model="searchValue"
            placeholder="Search By Movie"
            class="search_icon"
            type="search"
            id="searchMovie"
            @input="onSearchMovie($event)"
          ></b-form-input>
          <VkeyboardFloat
            :ID="'searchMovie'"
            :onClickFun="() => (showVKeyboard = !showVKeyboard)"
          />
          <Vkeyboard
            :inputName="'searchHeader'"
            :initialValue="searchValue"
            @changeKeyboardInput="searchValue = $event"
            @onChangeEvent="onSearchMovie($event)"
            :showOrHide="showVKeyboard"
            @onClickClose="
              () => {
                showVKeyboard = false;
              }
            "
          />

          <!-- <input type="search" placeholder="Search..." class="form-control" /> -->
          <div class="d-flex" v-if="routeName !== '/pos-login'">
            <div class="d-flex align-items-center">
              <div
                class="d-flex mr-1"
                style="align-item: center; white-space: nowrap"
              >
                <!-- <div v-if="routeName !== '/pos-login'" class="mx-2 text-blue">{{selectedCinema}}</div> -->
                <div class="text-blue" style="text-align: center">
                  {{ currentDate }}
                </div>
                <div>|</div>
                <div class="">
                  <!-- {{ currentTime }} -->
                  {{ (epixClient && twelhrtime) || currentTime }}
                </div>
              </div>

              <!-- <img
                v-if="getOrganizationDetails.hasOwnProperty('org_logo_url')"
                :src="getOrganizationDetails.org_logo_url"
                height="auto"
                width="80"
                class=""
              /> -->
            </div>
          </div>
          <div
            v-if="
              onChangeScreen &&
                enableSyncDualDisplay &&
                routeName.includes('/pos-seatlayout')
            "
          >
            <button
              class="btn-pos-menu d-flex align-items-center"
              style="border: none"
              v-on:click="posHeaderAction('refreshDualDisplay')"
            >
              <div class="svg-container">
                <div class="footer-icon-reload"></div>
              </div>
              <div>{{ "Sync Display" }}</div>
            </button>
          </div>
          <b-dropdown
            v-if="USERLOCATIONS.length > 1 && routeName !== '/pos-login'"
            right
            class="pos-header-dropdown"
            variant="pos-dropdown"
          >
            <template v-slot:button-content>
              <span>{{ getUserLocation }}</span>
            </template>
            <template>
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item
                :class="
                  selectedPosUserId == users.user_id ? 'disableLocation' : ''
                "
                :disabled="selectedPosUserId == users.user_id"
                :key="userIndex"
                v-for="(users, userIndex) in USERLOCATIONS"
                @click="OnChangeUserLocation(users)"
              >
                {{ users.cine_name }}
                <div class="text-muted fs-10 p-0 m-0">
                  {{ users.first_name }}&nbsp;{{
                    users.last_name ? users.last_name : ""
                  }}
                  <span
                    v-if="selectedPosUserId == users.user_id"
                    class="font-italic"
                    >&nbsp;(Logged)</span
                  >
                </div>
              </b-dropdown-item>
              <b-dropdown-divider></b-dropdown-divider>
            </template>
          </b-dropdown>

          <b-dropdown
            v-if="routeName !== '/pos-login'"
            right
            class="pos-header-dropdown pos-positioning-header"
            variant="pos-dropdown"
            @show="onCheckShift()"
          >
            <template v-slot:button-content>
              <span>{{ pos_user_name }}</span>
              <!-- <img
                src="@/assets/img/icons/user-profile.svg"
                style="width: 40px"
              /> -->

              <svg width="40" height="40" viewBox="0 0 40 40">
                <defs>
                  <filter id="colorize" color-interpolation-filters="sRGB">
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 0.305
                    0 0 0 0 0.4
                    0 0 0 0 0.082
                    0 0 0 1 0"
                    />
                  </filter>
                </defs>
                <image
                  style="filter: hue-rotate(45deg);"
                  xlink:href="data:image/png;base64,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"
                  x="0"
                  y="0"
                  width="40"
                  height="40"
                  filter=""
                />
              </svg>

              <!-- <span >{{ getUSINFO() }}</span> -->
            </template>
            <!-- <b-dropdown-item href="#">Settings</b-dropdown-item> -->
            <template v-if="!loading">
              <b-dropdown-divider></b-dropdown-divider>

              <!-- <b-dropdown-item @click="lockScreen()"
                >Lock Screen</b-dropdown-item
              > -->
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item
                v-if="
                  !isLogin &&
                    GetCinemaShiftIsActive &&
                    GetCinemaShiftIsActive === 'Y' &&
                    shiftRunning
                "
                v-on:click="onClickModal()"
                >Close Shift</b-dropdown-item
              >
              <b-dropdown-item v-if="checkClient" @click="openChrome()"
                >Manual Bills</b-dropdown-item
              >
              <!-- <b-dropdown-item @click="onChangeCacheMode()"
                >Cache Mode
              </b-dropdown-item> -->
              <b-dropdown-divider
                v-if="
                  !isLogin &&
                    GetCinemaShiftIsActive &&
                    GetCinemaShiftIsActive === 'Y' &&
                    shiftRunning
                "
              ></b-dropdown-divider>
              <b-dropdown-item @click="openCashDrawer('openCashDraw')"
                >Open Cash Drawer</b-dropdown-item
              >
              <b-dropdown-divider></b-dropdown-divider>

              <!-- <b-dropdown-item v-if="isLogin" v-on:click="onLogout()">Logout</b-dropdown-item> -->
              <b-dropdown-item
                v-if="
                  USE_TIM_INTEGRATION == 'Y' ||
                    USE_PLAY_ALHAMRA_CARD_MACHINE == 'Y'
                "
                v-on:click="configureSetting()"
                >Settings</b-dropdown-item
              >

              <b-dropdown-divider></b-dropdown-divider>

              <b-dropdown-item v-on:click="onLogout()">Logout</b-dropdown-item>
              <b-dropdown-divider></b-dropdown-divider>

              <b-dropdown-item>
                <span>
                  {{ semver }} <br />
                  <!-- {{ releaseVersion }} -->
                </span>
              </b-dropdown-item>

              <b-dropdown-divider v-if="DeviceUniqueCode"></b-dropdown-divider>
              <b-dropdown-item v-if="DeviceUniqueCode">
                <!---Device Name-->
                <div class="d-flex mr-3 text-nowrap">
                  <div class="text-blue" @click="configureHardware()">
                    Device - {{ DeviceUniqueCode }}
                  </div>
                </div>
                <!---Device Name-->
              </b-dropdown-item>
              <b-dropdown-divider
                v-if="CLIENT.STAR == CLIENT_SETUP_NAME"
              ></b-dropdown-divider>
              <b-dropdown-item
                v-on:click="onClickStoreManagement()"
                v-if="CLIENT.STAR == CLIENT_SETUP_NAME"
              >
                Store Settings&nbsp;<span class="edit-pen-sm"></span>
                <br />
                <span class="fs-12 text-muted">{{
                  getUserShiftData("sm_store_name") || "Update"
                }}</span>
              </b-dropdown-item>
            </template>
            <div v-else>
              <div class="loader"></div>
            </div>
          </b-dropdown>
        </div>

        <ManagerAuthLogin
          @AuthValid="onValidateAuth"
          :refId="'authManagerLoginPopup_posHeader'"
        />
        <ManagerAuthLogin
          :moduleName="'closeShiftAuth'"
          :onCheckAuth="onCheckAuthentication"
          :refId="'closeShiftAuth'"
        />
        <ManagerAuthLogin
          :moduleName="'openCashDraw'"
          :onCheckAuth="onCheckAuthentication"
          :refId="'openCashDraw'"
        />
        <PosSettingsPopup />
        <PosHardwarePopup />
        <div ref="onPrint" class="d-none">
          <div v-html="EjsData"></div>
        </div>
      </div>

      <b-modal
        id="confirmation_active_inactive"
        title="Confirmation"
        hide-footer
        hide-header
        centered
      >
        <div class="text-center pb-1 my-3">
          <p class="fs-16 mb-3">Do you want to Close Your Shift ?</p>
          <span class="mx-1"></span>
          <button
            class="btn btn-success btn-success-lg px-4 fs-14"
            v-on:click="onCloseShift()"
          >
            Yes
          </button>

          <button
            class="btn-outline-blue"
            @click.prevent.stop="$bvModal.hide('confirmation_active_inactive')"
          >
            Cancel
          </button>
        </div>
      </b-modal>

      <b-modal
        id="userStoreManagement"
        ref="userStoreManagement"
        title="Update Store"
        size="md"
        centered
        hide-footer
        no-fade
      >
        <div class="row h-100 versionBox">
          <div v-if="isStoreManagementLoading" class="pos-fnb-item-not-found">
            <div>
              <div>
                <b-spinner :variant="'primary'"></b-spinner>
              </div>
              <h6 class="pt-3 mb-2">Fetching Stores</h6>
              <h6>Please Wait...</h6>
            </div>
          </div>

          <template
            v-else-if="
              storeManagementArray.length > 0 && !isStoreManagementLoading
            "
          >
            <div
              v-for="(store, storeIndex) in storeManagementArray"
              :key="storeIndex"
              class="text-center mx-1"
            >
              <button
                :class="
                  `w-100 mb-3 fs-10 noHoverBtn ${
                    selectedStore && selectedStore.sm_id == store.sm_id
                      ? 'btn-blue'
                      : 'btn-outline-blue'
                  }`
                "
                @click="
                  () => {
                    selectedStore = store;
                  }
                "
              >
                {{ store.sm_store_name }}
              </button>
            </div>
          </template>

          <div v-else class="pos-fnb-item-not-found">
            <div>
              <h6 class="pt-3 mb-2">Opps!</h6>
              <h6>No Store Found!</h6>
            </div>
          </div>
        </div>

        <div class="text-center" v-if="storeManagementArray.length > 0">
          <button
            class="btn-sm btn-primary my-1 text-center"
            @click="
              () => {
                updateStoreManagement(true);
                $bvModal.hide('userStoreManagement');
              }
            "
          >
            {{ $t("Update Store") }}
          </button>
        </div>
      </b-modal>

      <b-modal
        id="confirmation_store_update"
        title="Confirmation"
        hide-footer
        hide-header
        centered
      >
        <div class="text-center pb-1 my-3">
          <p class="fs-16 mb-3">Do you want to Update Store ?</p>
          <span class="mx-1"></span>
          <button
            class="btn btn-success btn-success-lg px-4 fs-14"
            v-on:click="updateStoreManagement(false)"
          >
            Yes
          </button>

          <button
            class="btn-outline-blue"
            @click.prevent.stop="$bvModal.hide('confirmation_store_update')"
          >
            Cancel
          </button>
        </div>
      </b-modal>
    </div>
  </header>
</template>

<script>
  import languages from "@/helper/Languages";
  import Vkeyboard from "@/components/Partials/Vkeyboard.vue";
  import VkeyboardFloat from "@/components/Partials/keyboardFloatingToggle.vue";
  import ManagerAuthLogin from "@/components/Partials/AuthManagerLoginPopup";
  import PosSettingsPopup from "@/components/Partials/PosSettingsPopup.vue";
  import PosHardwarePopup from "@/components/Partials/PosHardwareSettingsPopup.vue";
  import PosService from "@/services/PosService";
  import MasterService from "@/services/MasterService";
  import Printd from "printd";
  import { BASEURL } from "@/config/index";
  import { backendSocket } from "@/main.js";
  import { createQueryString } from "@/services/ApiHelper";
  import moment from "moment";
  import axios from "axios";
  import { CLIENT_NAMES_OBJ, CLIENT_NAME } from "@/helper/Role";
  import { getHardwareId, getResourceUsageInfo } from "@/socket.io/init";

  export default {
    components: {
      Vkeyboard,
      VkeyboardFloat,
      ManagerAuthLogin,
      PosSettingsPopup,
      PosHardwarePopup,
    },
    props: {
      isLogin: {
        type: Boolean,
        default: false,
      },
      onChangeScreen: {
        type: Boolean,
        default: false, // Optional, but good to include if the prop is always required
      },
      section: {
        type: Object,
      },
      selectedFilterName: {
        type: String,
        default: "date",
      },
      onChangeFilter: {
        type: Function,
      },
      onClickHandler: {
        type: Function,
      },
      onSearchMovie: {
        type: Function,
      },
    },
    data() {
      return {
        tempCacheMode: false,
        cacheMode: false,
        fullScreen: false,
        pos_user_name: "",
        EjsData: "",
        paymentTypes: [],
        accessLimitation: "SUPER",
        selectedPosUser: "",
        selectedPosUserId: null,
        USERLOCATIONS: [],
        showVKeyboard: false,
        shiftRunning: false,
        loading: true,
        token: null,
        languages,
        selectedLanguage: "English",
        selectedCinema: "",
        DeviceUniqueCode: "",
        hardware_id: "",
        searchValue: "",
        noAuth: false,
        posShiftLog: {
          paymentTypes: [],
          grandTotal: 0,
          cine_include_shift_close: null,
          usl_id: null,
          user_shift_id: null,
        },
        currentDate: "",
        currentTime: "",
        twelhrtime: "",
        isStoreManagementLoading: false,
        storeManagementArray: [],
        selectedStore: {
          sm_id: null,
          sm_store_name: "",
        },
      };
    },
    computed: {
      CLIENT() {
        return CLIENT_NAME;
      },
      CACHE_MODE_POS() {
        return this.cacheModePos;
      },
      MANAGER_AUTH_FOR_CHANGES() {
        return this.$store.getters.MANAGER_AUTH_FOR_CHANGES;
      },
      SHOW_MERCHANDISE_MODULE() {
        return this.$store.getters.SHOW_MERCHANDISE_MODULE;
      },
      checkClient() {
        return this.authorizeClient(CLIENT_NAMES_OBJ.qfx);
      },
      getUserLocation() {
        return this.getUserDetail("cine_name");
      },
      getOrganizationDetails() {
        return this.$store.getters.getOrganizationDetails;
      },
      routeName() {
        return window.location.hash.replace("#", "");
      },
      disableClick() {
        return window.location.hash.replace("#", "").includes("pos-boo");
      },
      semver() {
        return "V 1.0.0";
      },
      GetCinemaShiftIsActive() {
        return window.localStorage.getItem("IS_SHIFT_CLOSE");
      },
      getCurrencyData() {
        return this.$store.getters.getCurrencyData;
      },
      USE_TIM_INTEGRATION() {
        return this.$store.getters.USE_TIM_INTEGRATION;
      },
      USE_PLAY_ALHAMRA_CARD_MACHINE() {
        let flag = "N";
        if (
          this.$store.getters.USE_CREDIT_CARD_MACHINE_PAYMENT == "Y" &&
          CLIENT_NAME.PLAYCINEMAS == this.CLIENT_SETUP_NAME
        ) {
          flag = "Y";
        }
        return flag;
      },
      epixClient() {
        console.log("Is There", CLIENT_NAME.EPIX == this.CLIENT_SETUP_NAME);
        return CLIENT_NAME.EPIX == this.CLIENT_SETUP_NAME;
      },
      enableSyncDualDisplay() {
        return CLIENT_NAMES_OBJ.enable_sync_dual_display.includes(
          this.CLIENT_SETUP_NAME
        );
      },
    },
    mounted() {
      this.tempCacheMode = this.cacheModePos;
      this.currentDate = this.getCurrentDateNew("ddd DD MMM", "calender");
      this.currentTime = this.getCurrentTime();
      this.accessLimitation = window.localStorage.getItem("USER_ROLE_NAME")
        ? window.localStorage.getItem("USER_ROLE_NAME")
        : "SUPER";
      this.DeviceUniqueCode = window.localStorage.getItem("deiviceUniqueCode")
        ? window.localStorage.getItem("deiviceUniqueCode")
        : "";
      this.getPosUserLocations();

      this.twelhrtime = this.twelhrtimeform;
      this.twelhrtimeform = function() {
        var twelhrtime = new Date();
        var hours = twelhrtime.getHours();
        var minutes = twelhrtime.getMinutes();
        var ampm = hours >= 12 ? "PM" : "AM";
        hours = hours % 12;
        hours = hours ? hours : 12;
        minutes = minutes < 10 ? "0" + minutes : minutes;
        var formattedTime = hours + ":" + minutes + " " + ampm;
        return formattedTime;
      };

      setInterval(() => {
        this.twelhrtime = this.twelhrtimeform();
      }, 1000);

      if (this.USE_PLAY_ALHAMRA_CARD_MACHINE == "Y") {
        this.loadAlhamraScriptsSequentially(null);
      }
    },
    methods: {
      loadAlhamraScriptsSequentially(ev = null) {
        const scriptsList = ["static/AlhamaraniCard/jquery.min.js"];

        const loadScript = (src) => {
          return new Promise((resolve, reject) => {
            const script = document.createElement("script");
            script.src = src;
            script.onload = () => {
              // If it's jQuery, expose it globally (important for Electron)
              if (src.includes("jquery.min.js")) {
                window.$ = window.jQuery = jQuery;
                console.log("✅ jQuery is now globally available!");
              }
              resolve(src);
            };
            script.onerror = () =>
              reject(new Error(`Failed to load script: ${src}`));
            document.body.appendChild(script);
          });
        };

        // Load scripts one by one
        const loadSequential = async () => {
          for (const script of scriptsList) {
            try {
              console.log(`Loading ${script}...`);
              await loadScript(script);
              console.log(`${script} loaded successfully.`);
            } catch (error) {
              console.error(error.message);
              break;
            }
          }
        };

        loadSequential();
      },
      onChangeCacheMode(event) {
        this.tempCacheMode = !this.tempCacheMode;
        window.localStorage.removeItem("fnb_items_array");
        window.localStorage.removeItem("fnb_categories");
        window.localStorage.removeItem("showDataCache");
        window.localStorage.removeItem("datesArray");
        window.localStorage.setItem(
          "cacheMode",
          this.tempCacheMode ? "Y" : "N"
        );
        this.cacheMode = this.tempCacheMode ? "Y" : "N";
        this.$toasted.show(
          !this.tempCacheMode ? "Cache Mode OFF" : "Cache Mode ON"
        );
      },
      posHeaderAction: function(menu_name, authCheck = true) {
        const log_menu_name = menu_name
          .split(/(?=[A-Z])/)
          .join(" ")
          .toUpperCase();

        this.sendAuditLogs({
          action: `POS USER CLICKS HEADER MENU - ${log_menu_name}`,
          page_name: "POS HEADER MENU",
          api_name: window.location.hash,
        });
        this.onClickHandler(menu_name);
      },
      openChrome() {
        var userAgent = navigator.userAgent.toLowerCase();
        if (userAgent.indexOf(" electron/") > -1) {
          try {
            this.$socket.emit("open-chrome");
          } catch (error) {
            console.log(error);
          }
        }
      },
      configureHardware() {
        this.$bvModal.show("posHardwareSettings");
        console.log("CLICKED configureHardware");
      },
      onClickStoreManagement() {
        this.getStoreManagement();
        this.$bvModal.show("userStoreManagement");
      },
      getStoreManagement() {
        if (this.CLIENT.STAR == this.CLIENT_SETUP_NAME) {
          let payload = {
            cine_id: this.getCinemaId(),
          };
          this.isStoreManagementLoading = true;
          this.storeManagementArray = [];
          this.selectedStore = {
            sm_id: null,
            sm_store_name: "",
          };
          PosService.getCinemaWiseStoreList(payload)
            .then((response) => {
              const { data } = response;
              if (data.status && data.Records.length > 0) {
                this.storeManagementArray = data.Records.filter(
                  (sm) => sm.sm_parent_id
                );
                const StoreManagementId = this.getUserShiftData("sm_id");
                console.log("selectedStore", this.selectedStore);
                this.selectedStore = this.storeManagementArray.find(
                  (store) => store.sm_id == StoreManagementId
                );
              }
            })
            .catch((err) => {
              console.log("Error:", err);
            })
            .finally(() => {
              this.isStoreManagementLoading = false;
            });
        }
      },
      updateStoreManagement(showConfirmation) {
        if (showConfirmation) {
          this.$bvModal.show("confirmation_store_update");
        } else if (!userShiftId) {
          this.$bvModal.hide("confirmation_store_update");
          this.$toasted.show("Shift ID Missing!");
        } else if (!this.selectedStore.sm_id) {
          this.$bvModal.hide("confirmation_store_update");
          this.$toasted.show("Please Select Store");
        } else {
          //Update Store
          this.showLoading();
          this.$bvModal.hide("confirmation_store_update");
          let userShiftId = this.getUserShiftData("us_id");
          let payloadObj = {
            user_shift_id: userShiftId,
            new_store_id: this.selectedStore.sm_id,
          };
          PosService.updateUserStoreManagement(payloadObj)
            .then((response) => {
              const { data } = response;
              this.$bvModal.hide("confirmation_store_update");
              if (data.status) {
                this.onLogout();
              } else {
                console.log("updateUserStoreManagement", data);
                this.$toasted.show(
                  "Unable to Update Store, Please Logout and Try Again!"
                );
              }
            })
            .catch((err) => {
              console.log("Error:", err);
              console.log("updateUserStoreManagement ERROR:", err);
              this.$toasted.show(
                "Unable to Update Store, Please Logout and Try Again!"
              );
            })
            .finally(() => {
              this.hideLoading();
            });
        }
      },
      onValidateAuth() {},
      onCheckAuthentication(response) {
        const { valid, name } = response;
        console.log(name, "nameeeeeee");
        if (valid) {
          this.$bvModal.hide(name);
          console.log("First Ifffffff Valid");
          // if (name == "openCashDraw ") {
          //   console.log("First Ifffffff");
          //   this.openCashDrawer(name, false);
          // }
        }
      },
      onSwitchToFnb() {
        this.sendAuditLogs({
          action: `SWITCH TO FNB PAGE`,
          page_name: "POS FNB",
          api_name: window.location.hash,
        });
        this.$router.push({
          path: "/pos-fnb",
        });
      },
      closeEftSession() {
        if (this.USE_TIM_INTEGRATION == "Y") {
          localStorage.setItem("ECR_INIT_STATUS", false);
          if (typeof deactivate == "function") {
            setTimeout(() => {
              deactivate();
            }, 1000);
          }
        }
      },
      onCheckShift() {
        this.loading = true;
        PosService.shiftChecker().then((response) => {
          const { data } = response;
          this.loading = false;
          if (data.status) {
            this.shiftRunning = data.shiftRunning;
          } else {
            this.shiftRunning = true;
          }
        });
      },
      getPaymentType: async function() {
        let body = {
          bs_id: 1,
        };
        MasterService.GetPaymentModes(body)
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              if (data.Records.length > 0) {
                let tempPaymentArray = [];

                data.Records.forEach((paymentType) => {
                  paymentType["no_of_slips"] = 0;
                  paymentType["amount"] = 0;
                  paymentType["remark"] = "";
                  tempPaymentArray.push(paymentType);
                });

                let userShiftDetails = { ...this.getUserShiftData() };
                userShiftDetails["payment_types"] = [...tempPaymentArray];
                localStorage.setItem(
                  "USER_SHIFT_DATA",
                  JSON.stringify(userShiftDetails)
                );
              }
            } else {
              this.toasted.show(data.message);
            }
          })
          .catch((error) => {
            this.toasted.show(error);
          });
      },
      printPosUserCollection: async function(isPrint = true) {
        let loggedUserId = this.getUserDetail("user_id");
        let payload = {
          user_id: loggedUserId,
          fromDate: moment(this.from_date || new Date()).format("YYYY-MM-DD"),
          toDate: moment(this.to_date || new Date()).format("YYYY-MM-DD"),
          isCurrentShift: "Y",
          isPrint: isPrint,
        };
        console.log('printPosUserCollection payload', payload);
        try {
          this.showLoading();
          var userAgent = navigator.userAgent.toLowerCase();
          if (userAgent.indexOf(" electron/") > -1) {
            try {
              const queryString = createQueryString(payload);

              if (this.$socket && isPrint) {
                console.log("socket_close_invoked", moment().format("YYYY-MM-DD HH:mm:ss"));
                if (this.authorizeClient(CLIENT_NAMES_OBJ.cinepolis)) {
                  this.$socket.emit("on_print_ticket", {
                    ttype: "dynamicURL",
                    dataURL: `${BASEURL}/api/pos/getUserCollection/${loggedUserId}${queryString}`,
                  });
                } else if (!this.authorizeClient(CLIENT_NAMES_OBJ.qfx)) {
                  console.log("Its printing here", queryString, loggedUserId);
                  this.$socket.emit("on_print_ticket", {
                    baseurl: BASEURL,
                    ttype: "pos_collection_summary",
                    user_id: loggedUserId,
                    queryString: queryString,
                  });
                }
                console.log("socket_close_invoked_123", moment().format("YYYY-MM-DD HH:mm:ss"));
              }

              this.hideLoading();
            } catch (err) {
              console.log("ERROR in SOcket", err);
            } finally {
              setTimeout(() => {
                this.hideLoading();
              }, 1000);
            }
          } else {
            const response = await PosService.getShiftCloseInvoiceSummary(
              payload
            );
            const { data } = response;
            
            console.log("printing here");
            this.EjsData = data;
            this.$nextTick(() => {
              this.hideLoading();

              if (!this.authorizeClient(CLIENT_NAMES_OBJ.qfx)) {
                const p = new Printd();
                if (this.$refs.onPrint && this.EjsData != null) {
                  p.print(this.$refs.onPrint, this.EjsData);
                  return;
                }
              }
            });
          }
        } catch (error) {
          console.log(error);
          this.hideLoading();
        }
      },
      onCloseShift: async function() {
        let isCloseShiftIncluded = window.localStorage.getItem(
          "IS_SHIFT_CLOSE"
        );
        // this.closeEftSession();
        if (isCloseShiftIncluded == "Y") {
          this.showLoading();

          try {
            await this.getPaymentType(); //gets payment modes
            await this.printPosUserCollection(); //prints the shift invoice
            setTimeout(async () => {
              await this.insertShiftClosePaymentData(); //updates the shift collection data and shift end.
            }, 2200)

            this.hideLoading();
          } catch (error) {
            this.$toasted.show("Shift not closed. Something went wrong.");
            this.hideLoading();
          } finally {
            setTimeout(() => {
              this.hideLoading();
            }, 100);
          }
        } else {
          window.localStorage.clear();
        }
      },
      updateShiftCloseData: async function() {
        let payload = this.getUserShiftData() || {};
        try {
          await PosService.OnClosePosUserShiftLog(payload);
        } catch (error) {
          console.log(error);
        }
      },
      insertShiftClosePaymentData: async function() {
        this.sendAuditLogs({
          action: `POS USER CLICKS SHIFT CLOSE, TOTAL CASH COLLECTED : ${this.getUserShiftData(
            "grandTotal"
          ) || 0} ${this.curr_code_mixin}`,
          page_name: "CLOSE SHIFT",
          api_name: "",
        });
        let userRoleName = window.localStorage.getItem("USER_ROLE_NAME");
        let userShiftData = this.getUserShiftData();
        let payload = {
          operator_type:
            userRoleName == "FnB POS Operator"
              ? "pos-fnb"
              : userRoleName == "POS Operator"
              ? "pos-booking"
              : "box-office-fnb", //'pos-fnb' // 'box-office-fnb'
          shift_id: userShiftData.usl_id,
          manager_user_id: userShiftData.manager_id,
          operator_user_id: userShiftData.user_id,
          currency_id: this.getCurrencyData.curr_id,
          scr_total_amount_collected: 0,
          scr_approval_status: false,
          scr_is_active: false,
          //
          shiftClosePayments: this.getUserShiftData("payment_types") || [],
          cashDenomination: [],
          Remark: "Auto Closed Shift",
          checkSkip: true,
        };
        try {
          this.showLoading();
          const response = await PosService.onCloseShift(payload);

          const { data } = response;
          if (data && data.status) {
            await this.updateShiftCloseData();
            this.$toasted.show(data.message);
            window.localStorage.clear();
            if (userRoleName == "FnB POS Operator") {
              this.$router.push({
                path: "pos-fnb-login",
              });
            } else {
              this.$router.push({
                path: "/",
              });
            }
          } else {
            this.$toasted.show(data.message);
          }
          this.hideLoading();
        } catch (error) {
          this.$toasted.show(err);
          this.hideLoading();
        }
      },
      getPosUserLocations() {
        let defaultUserId = localStorage.getItem("DFLT_USINFO")
          ? JSON.parse(localStorage.getItem("DFLT_USINFO"))
          : null;

        let user_info = localStorage.getItem("USER_INFO")
          ? JSON.parse(localStorage.getItem("USER_INFO"))
          : null;

        this.pos_user_name = user_info.username || "";
        // console.log(pos_user_name, "pos_user_name");

        if (defaultUserId && defaultUserId["user_id"]) {
          let payload = {
            user_id: defaultUserId["user_id"],
          };
          PosService.GetPosLocationsUsers(payload)
            .then((response) => {
              const { data } = response;
              if (
                data &&
                data.status &&
                data.Records &&
                data.Records.length > 0
              ) {
                this.USERLOCATIONS = data.Records;
                let loggedUserid = this.getUserDetail("user_id");
                let loggedUser = this.USERLOCATIONS.find(
                  (x) => loggedUserid == x.user_id
                );
                if (loggedUser) {
                  this.selectedPosUserId = loggedUser.user_id;
                  this.selectedPosUser = loggedUser;
                }
              } else {
                this.USERLOCATIONS = [];
              }
            })
            .catch((err) => {
              console.log("ERROR:", err);
            });
        } else {
          console.log(
            "COMING HERE IN ELSE getPosUserLocations",
            localStorage.getItem("DFLT_USINFO")
          );
          console.log(
            'COMING HERE IN ELSE localStorage.getItem("DFLT_USINFO").user_id',
            defaultUserId["user_id"]
          );
        }
      },
      OnChangeUserLocation(user) {
        let checkAccess = "";
        let defaultUserObj = localStorage.getItem("DFLT_USINFO")
          ? JSON.parse(localStorage.getItem("DFLT_USINFO"))
          : null;
        let defaultUserId = defaultUserObj["user_id"];
        let payload = {
          dflt_user_id: defaultUserId,
          new_user_id: user.user_id,
        };
        PosService.changeLoggedUserCinema(payload)
          .then(async (response) => {
            const { data } = response;
            console.log("data", data);
            let finalObj = {};
            let PromiseArray = this.usersArray.map((x) => {
              finalObj[x] = data.data.user[x] || null;
            });
            await Promise.all(PromiseArray);

            if (data.data.user && data.data.user.shift_id) {
              window.localStorage.setItem(
                "USER_INFO",
                finalObj ? JSON.stringify(finalObj) : {}
              );

              checkAccess = this.checkPosAccess(data.data.user);

              console.log("checkAccess", checkAccess);

              window.localStorage.setItem("JWT_TOKEN", data.data.token);

              if (
                data.hasOwnProperty("cinema_reponse") &&
                data.cinema_reponse &&
                data.cinema_reponse.length > 0 &&
                data.cinema_reponse[0].cinema_id &&
                ["4", "8"].includes(String(data.data.user.role_id))
              ) {
                window.localStorage.setItem(
                  "cinema_id",
                  data.cinema_reponse[0].cinema_id
                );
              } else if (["4", "8"].includes(String(data.data.user.role_id))) {
                window.localStorage.setItem("cinema_id", finalObj.cinema_id);
              }

              window.localStorage.setItem(
                "IS_SHIFT_CLOSE",
                data.data.user.cine_include_shift_close
              );

              window.localStorage.setItem("USER_ROLE_NAME", checkAccess);

              window.localStorage.setItem(
                "IS_INCLUDE_FLOAT_AMOUNT",
                data.data.user["cine_include_float_amount"]
              );

              if (checkAccess == "FNBONLY") {
                window.localStorage.setItem("isBOCalculator", false);
                await this.userShiftStart(
                  {
                    usl_id: data.data.user.user_id,
                    user_shift_id: data.data.user.shift_id,
                    cine_include_shift_close:
                      data.data.user.cine_include_shift_close,
                    cine_include_float_amount:
                      data.data.user.cine_include_float_amount,
                    page_name: "FNB_LOGIN",
                  },
                  data.data.token
                );
              } else {
                window.localStorage.setItem("isBOCalculator", true);
                await this.userShiftStart(
                  {
                    usl_id: data.data.user.user_id,
                    user_shift_id: data.data.user.shift_id,
                    cine_include_shift_close:
                      data.data.user.cine_include_shift_close,
                    cine_include_float_amount:
                      data.data.user.cine_include_float_amount,
                  },
                  data.data.token
                );
              }

              var userAgent = navigator.userAgent.toLowerCase();
              if (userAgent.indexOf(" electron/") > -1) {
                if (backendSocket && backendSocket.connected) {
                  backendSocket.emit("on_user_login", {
                    user: data.data.user,
                    hardware_id: this.hardware_id,
                  });
                }
              }

              this.sendAuditLogs({
                action: `USER CHANGE POS CINEMA LOCATION`,
                page_name: "FNB HEADER",
                api_name: window.location.hash,
              });
            } else {
              this.$toasted.show("Shift is Not Created For Selected Location");
            }
          })
          .catch((err) => {
            console.log("Error:", err);
          })
          .finally(() => {});
      },
      checkPosAccess(user) {
        let status = "";
        if ([4, 8].includes(user.role_id)) {
          if (user.pos_access == "Y" && user.fnb_access == "Y") {
            status = "SUPER";
          } else if (user.pos_access == "Y" && user.fnb_access == "N") {
            status = "POSONLY";
          } else if (user.pos_access == "N" && user.fnb_access == "Y") {
            status = "FNBONLY";
          }
        } else if ([13].includes(user.role_id)) {
          if (user.order_pickup_access_only == "Y") {
            status = "PICKUPKITCHEN";
          } else {
            status = "KITCHENUSER";
          }
        }
        return status;
      },
      userShiftStart: async function(shiftUserData, token) {
        this.showLoading();
        // await commit("SET_USER_SHIFT_DETAILS", payload);

        let hardwareMacAddress = window.localStorage.getItem(
          "hardware_mac_address"
        );
        let hardwareId = window.localStorage.getItem("deiviceUniqueCode");
        // functionality remaining
        if (!hardwareId || !hardwareMacAddress) {
          var userAgent = navigator.userAgent.toLowerCase();
          if (userAgent.indexOf(" electron/") > -1) {
            let sys_info = await getResourceUsageInfo();
            const key = Object.keys(sys_info.macAddress)[0];
            hardwareMacAddress = sys_info.macAddress[key].mac;
          }
        }
        // functionality remaining
        let requestPayload = {
          ...this.posShiftLog,
          hardware_id: window.localStorage.getItem("HWUID")
            ? window.localStorage.getItem("HWUID")
            : window.localStorage.getItem("deiviceUniqueCode")
            ? window.localStorage.getItem("deiviceUniqueCode")
            : null,
          hardware_name: window.localStorage.getItem("hardware_name")
            ? window.localStorage.getItem("hardware_name")
            : null,
          hardware_mac_address: window.localStorage.getItem(
            "hardware_mac_address"
          )
            ? window.localStorage.getItem("hardware_mac_address")
            : hardwareMacAddress
            ? hardwareMacAddress
            : null,
        };

        var config = {
          method: "post",
          url: `${BASEURL}/api/pos/pos-user-shift-log`,
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
          data: JSON.stringify(requestPayload),
        };

        axios(config)
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              this.posShiftLog = { ...this.posShiftLog, ...data.Records };
              if (data.Records.float_amount) {
                window.localStorage.setItem("FLOAT_AMOUNT_ADDED", "Y");
              } else {
                window.localStorage.setItem("FLOAT_AMOUNT_ADDED", "N");
              }

              if (shiftUserData["cine_include_float_amount"] == "N") {
                window.localStorage.setItem("FLOAT_AMOUNT_ADDED", "Y");
              }
              window.localStorage.setItem(
                "USER_SHIFT_DATA",
                JSON.stringify(this.posShiftLog)
              );
              window.localStorage.setItem(
                "USER_SHIFT_ID",
                this.posShiftLog.usl_id
              );

              if (!data.Records["inserted_new"]) {
                // USE WHEN WE NEED TO FORCE CLOSE SHIFT
                // router.replace({
                //     path: "close-shift"
                // });

                if (
                  shiftUserData["page_name"] &&
                  shiftUserData["page_name"] == "FNB_LOGIN"
                ) {
                  console.log("route to pos-fnb");
                  this.$router
                    .replace({
                      path: "/pos-fnb",
                    })
                    .catch((error) => {
                      if (
                        error.name !== "NavigationDuplicated" &&
                        !error.message.includes(
                          "Avoided redundant navigation to current location"
                        )
                      ) {
                        throw new Error(error);
                      } else {
                        window.location.reload();
                        console.log("Redundant navigation to current location");
                      }
                    });
                } else {
                  this.$router
                    .replace({
                      path: "/pos-booking",
                    })
                    .catch((error) => {
                      if (
                        error.name !== "NavigationDuplicated" &&
                        !error.message.includes(
                          "Avoided redundant navigation to current location"
                        )
                      ) {
                        throw new Error(error);
                      } else {
                        window.location.reload();
                        console.log("Redundant navigation to current location");
                      }
                    });
                }
              } else if (
                shiftUserData["page_name"] &&
                shiftUserData["page_name"] == "FNB_LOGIN"
              ) {
                if (
                  shiftUserData["cine_include_float_amount"] &&
                  shiftUserData["cine_include_float_amount"] == "Y"
                ) {
                  console.log("route to pos-fnb-cash");
                  this.$router
                    .replace({
                      path: "/pos-cash-input",
                      query: { nextRoute: "FNB_LOGIN" },
                    })
                    .catch((error) => {
                      if (
                        error.name !== "NavigationDuplicated" &&
                        !error.message.includes(
                          "Avoided redundant navigation to current location"
                        )
                      ) {
                        throw new Error(error);
                      } else {
                        window.location.reload();
                        console.log("Redundant navigation to current location");
                      }
                    });
                } else {
                  console.log("route to pos-fnb");
                  this.$router
                    .replace({
                      path: "/pos-fnb",
                    })
                    .catch((error) => {
                      if (
                        error.name !== "NavigationDuplicated" &&
                        !error.message.includes(
                          "Avoided redundant navigation to current location"
                        )
                      ) {
                        throw new Error(error);
                      } else {
                        window.location.reload();
                        console.log("Redundant navigation to current location");
                      }
                    });
                }
              } else if (
                shiftUserData["cine_include_float_amount"] &&
                shiftUserData["cine_include_float_amount"] == "Y"
              ) {
                this.$router
                  .replace({
                    path: "/pos-cash-input",
                    query: { nextRoute: "POS_LOGIN" },
                  })
                  .catch((error) => {
                    if (
                      error.name !== "NavigationDuplicated" &&
                      !error.message.includes(
                        "Avoided redundant navigation to current location"
                      )
                    ) {
                      throw new Error(error);
                    } else {
                      window.location.reload();
                      console.log("Redundant navigation to current location");
                    }
                  });
              } else {
                this.$router
                  .replace({
                    path: "/pos-booking",
                  })
                  .catch((error) => {
                    if (
                      error.name !== "NavigationDuplicated" &&
                      !error.message.includes(
                        "Avoided redundant navigation to current location"
                      )
                    ) {
                      throw new Error(error);
                    } else {
                      window.location.reload();
                      console.log("Redundant navigation to current location");
                    }
                  });
              }
              // window.location.reload();
            } else {
            }
          })
          .catch((error) => {})
          .finally(() => {
            setTimeout(() => {
              this.hideLoading();
            }, 1000);
          });
      },
      lockScreen() {},
      onClickModal() {
        this.$bvModal.show("confirmation_active_inactive");
      },
      configureSetting() {
        this.$bvModal.show("posSettingsModal");
      },
      updateShiftLogoutData: async function() {
        let shiftData = localStorage.getItem("USER_SHIFT_DATA");
        if (shiftData) {
          let payload = JSON.parse(shiftData);
          PosService.OnQuitPosUserShift(payload)
            .then((response) => {
              console.log("user logged out");
            })
            .catch((err) => {
              console.log(err);
            });
        }
      },
      onLogout: async function() {
        this.sendAuditLogs({
          action: `POS USER CLICKS LOGOUT BUTTON`,
          page_name: "LOGOUT",
          api_name: "",
        });

        var userAgent = navigator.userAgent.toLowerCase();
        if (userAgent.indexOf(" electron/") > -1) {
          if (backendSocket && backendSocket.connected) {
            backendSocket.emit("on_user_logout", {
              hardware_id: this.DeviceUniqueCode,
            });
          }
        }

        window.localStorage.clear();

        this.$router.push({
          path: "/",
        });
      },
      // openCashDrawer: function(menu_name, authCheck = true) {
      //   if (menu_name == "openCashDraw") {
      //     if (authCheck && this.MANAGER_AUTH_FOR_CHANGES == "Y") {
      //       this.$bvModal.show("openCashDraw");
      //     }
      //     try {
      //       this.sendAuditLogs({
      //         action: `POS USER OPEN CASH DRAWER`,
      //         page_name: "CASH DRAWER",
      //         api_name: "",
      //       });
      //       let cinema_id = localStorage.getItem("cinema_id");
      //       let userData = localStorage.getItem("USER_INFO") || "";
      //       if (this.$socket) {
      //         console.log(
      //           "print_ticket from pos_login3123425454 open cash drawer"
      //         );
      //         this.$socket.emit("on_print_ticket", {
      //           cinema_id,
      //           baseurl: BASEURL,
      //           ttype: "empire-login-ticket",
      //           openDrawer: "Y",
      //           loginDateTime: userData,
      //         });
      //         console.log("print_ticket from pos_login");
      //       }
      //     } catch (error) {
      //       console.log(error);
      //     }
      //   }
      // },
      openCashDrawer: async function(menu_name, authCheck = true) {
        if (menu_name === "openCashDraw") {
          if (authCheck && this.MANAGER_AUTH_FOR_CHANGES === "Y") {
            await this.$bvModal.show("openCashDraw");
          }
        }
      },
    },
  };
</script>

<style>
  .disableLocation {
    opacity: 0.5;
    cursor: not-allowed;
  }

  #userStoreManagement___BV_modal_content_ {
    zoom: 0.8;
  }

  .noHoverBtn:hover {
    color: white !important;
    background-color: var(--blue) !important;
  }

  .loader {
    border: 5px solid #f3f3f3;
    border-radius: 50%;
    border-top: 5px solid #3498db;
    width: 25px;
    height: 25px;
    -webkit-animation: spin 2s linear infinite;
    /* Safari */
    animation: spin 2s linear infinite;
    margin: 0 auto;
    margin-top: 10px;
    margin-bottom: 10px;
  }

  .alignment-header {
    justify-content: space-between;
  }

  @media screen and (max-width: 1000px) {
    .alignment-header {
      flex-wrap: nowrap;
    }
  }

  @media screen and (min-width: 1080px) and (max-width: 1500px) {
    .alignment-header {
      justify-content: space-between;
    }
  }

  @media screen and (min-width: 1100px) {
    .main {
      gap: 10px;
    }
  }

  /* Safari */
  @-webkit-keyframes spin {
    0% {
      -webkit-transform: rotate(0deg);
    }

    100% {
      -webkit-transform: rotate(360deg);
    }
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }

  .pos-positioning-header {
    position: absolute !important;
    right: 20px;
  }

  .disabled-click {
    cursor: not-allowed;
    pointer-events: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/Partials/posHeader.vue